import localforage from 'localforage';

const suggestionStorage = localforage.createInstance({
  name: 'GoPlausible-Algorand-Agency',
  storeName: 'suggestions',
  version: 1.0,
  description: 'Algorand Agency platform suggestions storage'
});

export interface Suggestion {
  id: string;
  content: string;
  order: number;
}

const defaultSuggestions: Suggestion[] = [
  { id: '1', content: 'Give me Algorand weather report', order: 1 },
  { id: '2', content: 'Get Agent wallet info', order: 2 },
  { id: '3', content: 'Give me a topup QRCode link for 2 Algos', order: 3 },
  { id: '4', content: 'Tell me about ARC 3 and ARC 19 NFTs', order: 4 },
  { id: '5', content: 'Tell me about ALPHA, 2200000000 and 871588583', order: 5 },
  { id: '6', content: 'Swap 1 Algo to USDC', order: 6 }
];

const suggestionStore = {
  async getSuggestions(): Promise<Suggestion[]> {
    try {
      const suggestions = await suggestionStorage.getItem<Suggestion[]>('suggestions');
      if (!suggestions) {
        return defaultSuggestions;
      }
      return suggestions;
    } catch (error) {
      console.error('Error getting suggestions from storage:', error);
      return defaultSuggestions;
    }
  },

  async setSuggestions(suggestions: Suggestion[]): Promise<void> {
    try {
      await suggestionStorage.setItem('suggestions', suggestions);
    } catch (error) {
      console.error('Error setting suggestions in storage:', error);
      throw error;
    }
  },

  async initializeDefaultSuggestions(): Promise<Suggestion[]> {
    try {
      await this.setSuggestions(defaultSuggestions);
      return defaultSuggestions;
    } catch (error) {
      console.error('Error initializing default suggestions:', error);
      return defaultSuggestions;
    }
  },

  async updateSuggestion(id: string, content: string): Promise<void> {
    try {
      const suggestions = await this.getSuggestions();
      const updatedSuggestions = suggestions.map(suggestion =>
        suggestion.id === id ? { ...suggestion, content } : suggestion
      );
      await this.setSuggestions(updatedSuggestions);
    } catch (error) {
      console.error('Error updating suggestion in storage:', error);
      throw error;
    }
  },

  async clear(): Promise<void> {
    try {
      await suggestionStorage.clear();
    } catch (error) {
      console.error('Error clearing suggestion storage:', error);
      throw error;
    }
  }
};

export { suggestionStore };